module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5497c727cab01a0290a73b1ff94997ee.png";